module.exports = __webpack_public_path__ + "static/media/RenzoeBox Website.5bcb7dfa.PNG";